module.exports = __webpack_public_path__ + "static/media/S3N13-4.8e4428db.svg";